// 库存盘点缓存

import { defineStore } from "pinia";

const useInventoryStore = defineStore("inventory", {
  state: () => ({
    checkInventoryStatus: '', // 盘点库存完成状态保存
    approvalInventoryStatus: '', // 审批库存完成状态保存
  }),
});

export default useInventoryStore;
